import React, { useEffect, useMemo, useState } from "react";

// Import components
import TableContainer from '../../components/Common/DataTableContainer';
import { Button } from "reactstrap";
import { formatDateTimeToAmPm } from "helpers/dateFormat_helper";
import axiosInstance from "pages/Utility/axiosInstance";
import { showSuccess } from "helpers/notification_helper";
import Cookies from "js-cookie";
import { FaTimesCircle, FaCheckCircle } from "react-icons/fa";

import { Tooltip } from 'react-tooltip';

const ExtentionTable = ({ List, handleSubmit }) => {

  const userId = JSON.parse(Cookies.get('authUser'))?.userId
  // Table columns definition
  const columns = useMemo(
    () => [
      {
        header: 'WorkOrder Number',
        accessorKey: 'workOrderNumber',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Requested By',
        accessorKey: 'requestedBy',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Reason',
        accessorKey: 'extensionReason',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <>
            <div
              data-tooltip-id="reason-tooltip" // Specify the tooltip ID
              data-tooltip-content={row.original?.extensionReason} // Tooltip content
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
                cursor: 'pointer',
              }}
            >
              {row.original?.extensionReason}
            </div>
            <Tooltip id="reason-tooltip" place="top" 
            style={{ 
              zIndex: 9999 ,
              maxWidth: '300px',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              color: 'white',
              padding: '10px',
              borderRadius: '8px',
              fontSize: '14px',
              textAlign: 'center',
              lineHeight: '1.5',
              display: 'block',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }} 
            />
          </>
        ),
      },
      {
        header: 'Proposed End Date',
        accessorKey: 'proposedEndDateTime',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <span>
            {formatDateTimeToAmPm(row.original?.proposedEndDateTime)}
          </span>
        )
      },
      {
        header: 'New End Date',
        accessorKey: 'newEndDateTime',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <span>
            {formatDateTimeToAmPm(row.original?.newEndDateTime)}
          </span>
        )
      },
      {
        header: 'Actions',
        id: 'actions',
        cell: ({ row }) => {
          const handleApprove = async () => {
            try {
              const response = await axiosInstance.post('', {
                "sp": "usp_ApproveWorkOrderExtension",
                "extensionId": row.original.extensionId,
                "approvedBy": userId,
                "approvalReason": ""

              })
              if (response) {
                handleSubmit();
                showSuccess("Extension request is Approved ")
              }
            } catch (error) {

            }
          };

          const handleDelete = async () => {
            try {
              const response = await axiosInstance.post('', {
                "sp": "usp_RejectWorkOrderExtension",
                "extensionId": row.original.extensionId,
                "updatedBy ": userId

              })
              if (response) {
                handleSubmit();
                showSuccess("Extension request is rejected ")
              }
            } catch (error) {

            }

          };

          return (
            <div className="d-flex gap-2">
              <Button color="primary" title="Approve" onClick={handleApprove} className="mr-2 d-flex align-items-center">
                <FaCheckCircle size={18} />
              </Button>
              <Button color="danger" title="Reject" onClick={handleDelete} className="mr-2 d-flex align-items-center">
                <FaTimesCircle size={18} />
              </Button>
            </div>
          );
        },
      },
    ],
    [List]
  );

  // Meta title
  document.title = "Extention Management | Admin Dashboard";

  return (
    <>
      <div className="">
        <div className="container-fluid">
          <TableContainer
            columns={columns}
            data={List || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder="Search..."
            pagination="pagination"
            docName="Work Order Extensions"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </div>
      </div>
    </>
  );
};

export default ExtentionTable;
